import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 70vh;
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  width: 96%;
  min-height: 60vh;
  height: 82vh;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;

  div {
    width: 250px;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
      span {
        font-weight: 700;
        color: var(--red);
      }
    }

    img {
      width: 90%;
      height: 60%;
      border-radius: 6px;
    }
  }
`;
